export default __webpack_public_path__ + "static/media/hipercentro.f5ff414e.png";